import {
  AudiencePurchasedAtLeastTargetingAttributeFragment,
  AudiencePurchasedAtMostTargetingAttributeFragment,
} from '@occc/graphql';
import { TransactionsMemberPurchasedOperator } from '../constants';

export const mapTypenameToMemberPurchasedOperator = (
  __typename:
    | AudiencePurchasedAtLeastTargetingAttributeFragment['__typename']
    | AudiencePurchasedAtMostTargetingAttributeFragment['__typename'],
  excludeThreshold?: boolean | null,
): TransactionsMemberPurchasedOperator => {
  let type: TransactionsMemberPurchasedOperator = TransactionsMemberPurchasedOperator.MoreThan;

  if (excludeThreshold === null || excludeThreshold === undefined) {
    return type;
  }

  if (__typename === 'AudiencePurchasedAtLeastTargetingAttribute') {
    type = excludeThreshold
      ? TransactionsMemberPurchasedOperator.MoreThan
      : TransactionsMemberPurchasedOperator.MoreOrEqualTo;
  }

  if (__typename === 'AudiencePurchasedAtMostTargetingAttribute') {
    type = excludeThreshold
      ? TransactionsMemberPurchasedOperator.LessThan
      : TransactionsMemberPurchasedOperator.LessThanOrEqualTo;
  }

  return type;
};
